import api from './api';

// Fechas disponibles de órdenes de preparación
export const getPrepOrderDates = (storeId) =>
  api.get('/prep-ordering/view/dates', { params: { storeId } }).then(r => r.data);

// Órdenes de preparación de una fecha
export const getPrepOrdersForView = (storeId, filterDate) =>
  api.get('/prep-ordering/view', { params: { storeId, filterDate } }).then(r => r.data);

// Eliminar una orden de preparación
export const deletePrepOrder = (id) =>
  api.delete(`/prep-ordering/view/${id}`).then(r => r.data);